import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<path
				d="M12 6 L13.5 10 L17.5 10 L14.5 12.5 L15.5 16.5 L12 14 L8.5 16.5 L9.5 12.5 L6.5 10 L10.5 10 Z"
				fill="white"
			/>
		</svg>
	);
	return icon;
}

export default icon;
